<template>
	<transition name="transition">
		<nav
			id="mobile-nav"
			v-if="isShowing"
			:style="{'--height': primaryMenuHeight + 'px'}"
		>
			<div
				class='touch-close'
				@click="toggleMobileMenu()"
			></div>
			<div class="mobile-menu">
				<div
					class="mobile-menu__inner"
					v-bind:style="{ height: primaryMenuHeight + 'px' }"
				>
					<ul
						class="mobile-menu-links"
						v-if="menuData"
					>

						<li
							v-for="post in menuData"
							:key="post.ID"
							:class="post.classes"
							data-aos="fade-left"
							data-aos-duration="750"
							data-aos-delay="750"
						>
							<h5
								v-html="post.title"
							></h5>

							<ul v-if='post.children'>
								<li
									v-for="sub_post in post.children"
									:key="sub_post.ID"
								>
									<a
										:class="{
                    selected: sub_post.object_id == currentId,
                  }"
										:href="sub_post.url"
										:target="sub_post.target"
										v-html="sub_post.title"
									>
									</a>
								</li>
							</ul>

						</li>

					</ul>

					<div
						class='contact_details'
						v-html="globalSettings.footer.contact_details"
						data-aos="fade-left"
						data-aos-duration="750"
						data-aos-delay="1100"
					></div>

				</div>
			</div>
			<!-- <div
				class="overlay"
				:class="{'visible': isShowing}"
			></div> -->
		</nav>
	</transition>
</template>

<script>
import Arrow from '../../images/arrow-basic.svg';
// import PrimaryButton from './PrimaryButton.vue';

export default {
	data() {
		return {
			selectedPrimaryPost: null,
			selectedSecondaryPost: null,
			selectedTertiaryPost: null,
			selectedMenuData: null,
			arrow: Arrow,
			searchQuery: '',

			depth: 0,
			primaryMenuHeight: 300,

			selectedMenu0: null,
			selectedMenu1: null,
			selectedMenu2: null,
			selectedMenu3: null,
			// isShowingMenu: this.isShowingMenu ? this.isShowingMenu : false,
		};
	},

	props: {
		menuData: {
			type: Array,
			default: function () {
				return [];
			},
		},
		globalSettings: {},
		currentId: {
			type: Number,
			default: -1,
		},
		isShowing: {
			type: Boolean,
			default: false,
		},
		showHomeLink: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		menuForDepth1: function () {
			return this.selectedMenu0 ? this.selectedMenu0.children : [];
		},
		menuForDepth2: function () {
			return this.selectedMenu1 ? this.selectedMenu1.children : [];
		},
		menuForDepth3: function () {
			return this.selectedMenu2 ? this.selectedMenu2.children : [];
		},
	},

	watch: {
		// depth: function (newValue, oldValue) { // eslint-disable-line no-unused-vars
		//   //this.layoutSubviews();
		// },
		// isShowing: function (newValue, oldValue) {
		//   // if(newValue) {
		//   //
		//   // }
		// },
	},

	methods: {
		toggleMobileMenu() {
			console.log('Clicked');
			this.$store.commit('toggleMobileMenu', !this.$store.state.mobile_menu);
		},

		layoutSubviews: function () {
			var height = 0,
				panelEl = this.$refs['menuDepth' + this.depth];

			if (typeof panelEl === 'undefined') return;

			height = panelEl.clientHeight;
			this.primaryMenuHeight = height;
		},
		didSelectBack: function () {
			if (this.depth > 0) {
				this.depth -= 1;
			}
		},
		didSelectPost: function (item, ignoreChildren = false) {
			const self = this;

			if (item.children && !ignoreChildren) {
				var newDepth = item.depth + 1;

				switch (newDepth) {
					case 1:
						{
							self.selectedMenu0 = item;
						}
						break;

					case 2:
						{
							self.selectedMenu1 = item;
						}
						break;

					case 3:
						{
							self.selectedMenu2 = item;
						}
						break;

					default:
				}

				self.depth = newDepth;

				return;
			}

			window.location.href = item.url;
			// self.isShowingMenu = false;
		},
	},

	components: {
		// PrimaryButton,
		//PoseTransition,
	},

	mounted() {
		var self = this;
		setTimeout(function () {
			self.layoutSubviews();
		}, 150);
	},

	updated() {
		this.layoutSubviews();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

$mobile-menu-item-min-height: 72px;
$mobile-menu-footer-min-height: 82px;

/* .overlay {
	position: absolute;
	z-index: var(--z-index-bottom);
	top: 0;
	right: 0;
	bottom: 100%;
	left: 0;
	width: 100%;
	height: 100vh;
	background: rgba(0, 0, 0, 0.5);
	pointer-events: none;
	opacity: 0;
	pointer-events: none;

	&.visible {
		opacity: 1;
	}
} */

#mobile-nav {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	/* z-index: 155; */
	-webkit-overflow-scrolling: touch;

	.touch-close {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
	}

	.scrolled & {
		position: fixed;
		/* top: 84px;
		background-color: transparent;
		height: var(--height);

		&::before {
			content: '';
			position: absolute;
			top: -84px;
			left: 0;
			right: 0;
			height: 84px;
			background: var(--chartruese-green);
		}

		.mobile-menu {
			background-color: var(--chartruese-green);

			&__inner {
				background-color: var(--chartruese-green);
			}
		} */
	}

	/* .admin-bar & {
		//top: $header-height-xs + $admin-bar-height-xs;
		padding-top: $header-height-xs + $admin-bar-height-xs;

		@media (max-width: $tablet) {
			//top: $header-height-xs + $admin-bar-height;
			padding-top: $header-height-xs + $admin-bar-height;
		}
	} */

	&.fade-enter-active,
	&.fade-leave-active {
		transition: opacity 0.25s;

		.container {
			transition: transform 0.25s;
		}
	}

	&.fade-enter,
	&.fade-leave-to {
		opacity: 0;
	}

	&.fade-leave-to {
		.container {
			transform: translateY(-10px);
		}
	}

	&.transition-enter-active,
	&.transition-leave-active {
		transition: transform 1s ease-in-out, opacity 1s ease-in-out;
	}

	&.transition-enter-active {
		transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
	}

	&.transition-leave-active {
		transition-timing-function: cubic-bezier(0.36, 0, 0.22, 0);
	}

	&.transition-enter,
	&.transition-leave-to {
		transform: translateX(120%);
	}

	.mobile-menu {
		/* position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0; */
		/* overflow: auto;
		display: flex;
		flex-direction: column;
		justify-content: space-between; */
		top: 150px;
		background: transparent;
		transition: 0.2s ease all;
		justify-content: flex-end;
		display: flex;
		position: relative;
		pointer-events: none;
		transition: 0.2s ease all;

		.scrolled & {
			top: 50px;
			transition: 0.2s ease all;

			@media (max-width: $mobile) {
				top: 0;
			}
		}

		@media (max-width: $mobile) {
			top: 0;
			height: 100vh;
		}

		&__inner {
			position: relative;
			overflow: hidden;
			color: var(--duco-blue);
			transition: 0.2s ease all;
			height: calc(100vh - 150px) !important;
			width: calc(50vw - 150px) !important;
			right: 0;
			border-left: var(--border);
			border-top: var(--border);
			pointer-events: all;
			padding: 75px;
			background: var(--black);

			@media (max-width: $mobile) {
				width: calc(100% - 48px) !important;
				border-left: unset;
				border-top: unset;
				padding: 101px var(--gutter-mobile);
				height: 100% !important;
			}

			.back {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				/* min-height: $mobile-menu-footer-min-height; */
				position: relative;
				text-decoration: none;
				color: var(--duco-blue);
				opacity: 1;
				gap: 9.5px;
				font: normal normal bold 14px/18px var(--primary-font-family);
				letter-spacing: 0.14px;
				padding: 24px 0 24px;

				&:hover,
				&:active {
					text-decoration: none;
					opacity: 1;
				}

				svg {
					transform: rotate(-180deg);

					path {
						stroke: var(--duco-blue);
					}

					line {
						stroke: var(--duco-blue);
					}
				}
			}
		}

		.mobile-menu-links {
			list-style: none;
			margin: 0;
			padding: 0;
			display: flex;
			flex-direction: column;
			gap: 10px;

			> li {
				margin: 0;
				padding: 0;
				display: block;
				display: flex;
				flex-direction: column;

				&:first-child {
					border-top: none;
				}

				> img {
					padding: 0;

					&:hover {
						cursor: pointer;
					}
				}

				h5,
				.post-title {
					color: grey;
					text-transform: uppercase;
					font-family: var(--primary-font-family);
					font-style: normal;
					font-weight: bold;
					font-size: 14px;
					line-height: 20px;
					letter-spacing: 0.28px;

					/* &:hover {
						text-decoration: underline;
					} */
				}

				> ul {
					list-style: none;
					margin: 0;
					padding: 0;
					display: flex;
					flex-direction: column;

					li {
						a {
							color: var(--white);
							font-size: 22px;
							line-height: 32px;
							text-decoration: none;

							&:hover {
								color: var(--duco-blue);
								cursor: pointer;
								text-decoration: underline;
							}
						}
					}
				}

				> a,
				> div {
					position: relative;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					/* min-height: $mobile-menu-item-min-height; */
					color: var(--white);
					opacity: 1;
					text-decoration: none;
					padding: 0;
					width: 100%;
					column-gap: 16px;

					&:hover,
					&:active {
						text-decoration: none;
						opacity: 1;
						cursor: pointer;

						&::before {
							opacity: 1;
							//background-color: map-get($theme-colours, ocean-blue);
						}

						&::after {
							transform: translateX(5px);
						}
					}

					&.selected {
						//color: map-get($theme-colours, ocean-blue);
						opacity: 0.7;

						&.has-children {
							&:hover,
							&:active {
								text-decoration: none;
							}
						}
					}
				}
			}

			.site_button {
				margin-top: 40px;
			}
		}

		.contact_details {
			margin-top: 40px;

			&::v-deep {
				p {
					margin: 0 0 16px;
					color: var(--white);
					font-size: 14px;
					line-height: 20px;

					&:last-of-type {
						margin: 0 0;
					}
				}
			}
		}
	}
}

.fade-enter-active {
	animation: fade-in 0.25s;
}

.fade-leave-active {
	animation: fade-in 0.25s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MobileMenu.vue